import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { httpConfirmCsvUpload } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { CSV_UPLOADS_QUERY_KEY } from './use-get-csv-uploads'

export const useConfirmCsvUpload = (
	options?: Omit<UseMutationOptions<unknown, unknown, string>, 'mutationFn'>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (id: string) => httpConfirmCsvUpload(id),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({ queryKey: [CSV_UPLOADS_QUERY_KEY] })
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
